(function () {
  var SECTION_SELECTOR = '.oddit-section-scrolling-banner';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      // Use fractional box width (getBoundingClientRect), NOT scrollWidth — the
      // latter is rounded to an integer, so the loop reset would be off by up to
      // ~1px every cycle, producing the periodic jump/jitter.
      var setWidth = firstSet.getBoundingClientRect().width;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    // Observe the set itself (not just the section): its width changes when the
    // web font swaps in or content reflows, even though the section stays 100%.
    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);
    ro.observe(firstSet);

    // Re-measure once web fonts finish loading — the Oswald swap changes text
    // width, and a stale distance would cause a one-time jump on first cycles.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!reducedMotion.matches) measure();
      });
    }

    function handleMotionChange(e) {
      e.matches ? disable() : enable();
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleMotionChange);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(handleMotionChange);
    }

    function handleVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      handleMotionChange: handleMotionChange,
      handleVisibilityChange: handleVisibilityChange
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.handleMotionChange) {
      if (state.reducedMotion.removeEventListener) {
        state.reducedMotion.removeEventListener('change', state.handleMotionChange);
      } else if (state.reducedMotion.removeListener) {
        state.reducedMotion.removeListener(state.handleMotionChange);
      }
    }
    if (state.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', state.handleVisibilityChange);
    }
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;
    var marquee = initMarquee(section);
    sectionState.set(section, { marquee: marquee });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();